export const i18Namespace = {
  translation: "translation",
  validForm: "validForm",
  toast: "toast",
};

export const i18TranslationNS = i18Namespace.translation;
export const i18ValidFormNS = i18Namespace.validForm;
export const i18ToastNS = i18Namespace.toast;
